/*
   小强 方法
 */
import * as HttpService from "../../../../service/HttpService";

/**
 * 新增用户
 */
export const addOrModifyUser = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/addOrModifyUser", params);
}
export const operationRes = (params, ceResClass, ceResSortNo, flag) => {
    if (flag === 1) {
        if (ceResClass === 0) {
            return addOrModifyUser(params);
        } else if (ceResClass === 1) {
            return addOrModifyCntr(params);
        } else if (ceResClass === 3 && ceResSortNo === "DIST_SWITCHING_ROOM") {
            return addOrModifyCntr(params);
        } else {
            return addOrModifyDevice(params);
        }
    } else {
        if (ceResClass === 1) {
            return addOrModifyUser(params);
        } else if (ceResClass === 3) {
            return addOrModifyCntr(params);
        } else {
            return addOrModifyDevice(params);
        }

    }
}


export const addOrModifyCntr = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/addOrModifyCntr", params);
}

export const addOrModifyDevice = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/addOrModifyDevice", params);
}

/**
 * 获取资源详细信息
 */
export const getResDetailInfoById = (id, ceResClass) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getResDetailInfoById?id=" + id + "&ceResClass=" + ceResClass);
}

/**
 * 删除资源
 */
export const deleteResInfoById = (ds) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/deleteResInfoById", ds);
}

/**
 * 获取电压等级
 */
export const getSelectListInfo = (id, ceResClass, ceResSortNo) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getSelectListInfo?id=" + id + "&ceResClass=" + ceResClass + "&ceResSortNo=" + ceResSortNo);
}

/**
 * 获取终端
 */
export const getTermInfo = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getTermInfo?id=" + params.id + "&termAddr=" + params.termAddr);
}
/**
 * 获取终端
 */
export const getMeterInfo = (id) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getMeterInfo?id=" + id);
}

/**
 * 获取终端
 */
export const getLowerClass = (ceResClass, ceResSortNo, ceTreeNo) => {
    return HttpService.get(HttpService.DOMAIN + "/cust/getLowerClass?ceResClass=" + ceResClass + "&ceResNo=" + ceResSortNo + "&cetreeSortNo=" + ceTreeNo);
}


export const getTreeNodeTemplateProps = (ceResSortNo) => {

    return HttpService.get(HttpService.DOMAIN + "/ceResource/getTreeNodeTemplateProps?ceResSortNo=" + ceResSortNo);
};

export const isChildrenOrgNo = () => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/isChildrenOrgNo");
};

/* 
获取企业（园区）列表
*/
export const getChildrenOrgAndExtList = (data) => {
    return HttpService.get(HttpService.DOMAIN + "/sysmgmt/orgmgmt/getChildrenOrgAndExtList?orgName=" + data.orgName + "&phone=" + data.phone + "&address=" + data.address);
};
/* 
编辑企业园区额外扩展信息
*/
export const editOrgExtDo = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgExtMgmt/editOrgExtDo", data);
};
/* 
新增企业园区额外扩展信息。
*/
export const addOrgExtDo = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgExtMgmt/addOrgExtDo", data);
};
